<template>
    <app-layout>
        <template v-slot:header>
            <Header :title="$t('my_requests')"
                    :isFilter="false">
            </Header>
        </template>
        <template v-slot:header-mobile>
            <HeaderMobile :title="$t('my_requests')"
                          :isFilter="false">
            </HeaderMobile>
        </template>
        <b-tabs content-class="py-5 position-relative" v-model="tabIndex">
            <div class="tabs-bottom-line"></div>
            <!-- Reimbursement Form Tab -->
            <b-tab v-if="checkPermission('reimbursementform_myrequests')">
                <template #title>
                    <span class="d-flex align-items-center">{{ $t('reimbursement_form') }}</span>
                </template>
                <div class="d-flex justify-content-end mb-2">
                    <b-button
                        v-if="checkPermission('reimbursementform_store')"
                        variant="primary"
                        class="mr-2"
                        @click="$router.push('/reimbursement/request-form')"
                    >
                        {{ $t('new_request') }}
                    </b-button>
                </div>
                <ReimbursementForm
                    v-if="tabIndex === indexes.reimbursementForm"
                    :filter="filter"
                />
            </b-tab>

            <!-- Catering Requests Tab -->
            <b-tab v-if="checkPermission('cateringform_myrequests') && isLeadershipTeam">
                <template #title>
                    <span class="d-flex align-items-center">{{ $t('catering_requests') }}</span>
                </template>
                <div class="d-flex justify-content-end mb-2">
                    <b-button
                        v-if="checkPermission('cateringform_store')"
                        variant="primary"
                        class="mr-2"
                        @click="$router.push('/catering/request-form')"
                    >
                        {{ $t('new_request') }}
                    </b-button>
                </div>
                <CateringRequest
                    v-if="tabIndex === indexes.cateringRequest"
                    :filter="userFilter"
                />
            </b-tab>

            <!-- Purchase Order Form Tab -->
            <b-tab v-if="checkPermission('purchaseorderform_myrequests') && isLeadershipTeam">
                <template #title>
                    <span class="d-flex align-items-center">{{ $t('purchase_orders') }}</span>
                </template>
                <div class="d-flex justify-content-end mb-2">
                    <b-button
                        v-if="checkPermission('purchaseorderform_store')"
                        variant="primary"
                        class="mr-2"
                        @click="$router.push('/purchase-order/request-form')"
                    >
                        {{ $t('new_request') }}
                    </b-button>
                </div>
                <PurchaseOrderForm
                    v-if="tabIndex === indexes.purchaseOrderForm"
                    :filter="userFilter"
                />
            </b-tab>

        </b-tabs>
    </app-layout>
</template>

<script>
import AppLayout from "@/layouts/AppLayout.vue";
import Header from "@/layouts/AppLayout/Header.vue"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue"
import ReimbursementForm from "@/modules/staff/pages/components/Reimbursement/Form.vue";
import CateringRequest from "@/modules/staff/pages/components/CateringRequest.vue";
import PurchaseOrderForm from "@/modules/staff/pages/components/PurchaseOrderForm.vue";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        ReimbursementForm,
        CateringRequest,
        PurchaseOrderForm
    },
    data() {
        return {
            tabIndex: 0,
        }
    },
    metaInfo() {
        return {
            title: this.$t("my_requests")
        }
    },
    computed: {
        stateData() {
            return this.$store.getters['auth/getUser'] || {};
        },
        isLeadershipTeam() {
            return !!(this.stateData && this.stateData.staff && this.stateData.staff.is_leadership_team);
        },
        indexes() {
            let currentIndex = 0;
            const reimbursementForm = this.checkPermission('reimbursementform_myrequests') ? currentIndex++ : -1;
            const cateringRequest = (this.checkPermission('cateringform_myrequests') && this.isLeadershipTeam) ? currentIndex++ : -1;
            const purchaseOrderForm = (this.checkPermission('purchaseorderform_myrequests') && this.isLeadershipTeam) ? currentIndex++ : -1;
            return {
                reimbursementForm,
                cateringRequest,
                purchaseOrderForm
            };
        },
        userFilter() {
            if (!this.stateData || !this.stateData.id) return {};
            return {
                params: {
                    user_id: this.stateData.id,
                }
            };
        },
        filter() {
            if (!this.stateData || !this.stateData.id) return {};
            return {
                params: {
                    staff_id: this.stateData.id,
                }
            };
        }
    },
    created() {
        this.$store.dispatch("auth/initUser");

        if (this.$route.params.tab) {
            this.tabIndex = parseInt(this.$route.params.tab)
        }
    },
}
</script>

<style lang="scss">
.document_request_dropdown {
    tr {
        td:first-child {
            padding-right: 0px !important;
        }
    }
}
</style>
